import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
  ApiBlobGetRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Daftar Slip Gaji',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Slip Gaji',
        href: '/adm/slip-gaji',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_slip_gaji',
    sortDesc: true,
    fields_periode: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'kode_periode',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'tgl_slip',
        label: 'Tgl Slip',
        sortable: true,
      },
      {
        key: 'tgl_periode',
        label: 'Periode',
        sortable: true,
      },
      {
        key: 'total_karyawan',
        label: 'Total Karyawan',
        sortable: true,
      },
      {
        key: 'nama_pabrik',
        label: 'Pabrik',
        sortable: true,
      },
      {
        key: 'total_slip',
        label: 'Total',
        sortable: true,
      },
      {
        key: 'status_periode',
        label: 'Status',
      },
      {
        key: 'aksi',
        thStyle: {
          textAlign: 'center',
        },
        label: 'Aksi',
      },
    ],
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'kode_slip',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'nm_karyawan',
        label: 'Nama Karyawan',
        sortable: true,
      },
      {
        key: 'total_slip',
        label: 'Total Slip',
        sortable: true,
      },
      {
        key: 'nm_dept',
        label: 'Departemen',
        sortable: true,
      },
      {
        key: 'tgl_slip',
        label: 'Tgl Slip',
        sortable: true,
      },
      {
        key: 'tgl_periode',
        label: 'Periode',
        sortable: true,
      },
      {
        key: 'nama_pabrik',
        label: 'Pabrik',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    detail_periode: false,
    form: {
      dist_code: '',
      dist_company: '',
      dist_address: '',
      dist_email: '',
      dist_phone: '',
    },
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeSlipGaji(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchSlipGaji(context, params = null) {
    let result = await ApiGetRequest(`slip-gaji`, params);
    return !result.error ? result.data.object : [];
  },

  async getDetailSlipPeriode({ commit }, payload = null) {
    commit('changeSlipGaji', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `slip-gaji/periode/${payload.id_slip_periode}`,
    );
    commit('changeSlipGaji', {
      loading: false,
      detail_periode: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async getExportTemplate({ commit, state }, payload = {}) {
    commit('changeSlipGaji', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      sort: 'nm_karyawan',
      order: 'asc',
      export: 1,
      ...payload,
    };

    let result = await ApiBlobGetRequest(
      `slip-gaji/template/${data.id_slip_periode}`,
      params,
    );
    commit('changeSlipGaji', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      var blob = new Blob([result.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'export_slip_gaji.xlsx';

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);

      commit('changeSlipGaji', {
        loading: false,
      });

      return true;
    }
  },

  async getListDetailSlipGaji({ commit, state }, payload = {}) {
    commit('changeSlipGaji', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(
        `slip-gaji/detail/${data.id_slip_periode}`,
        params,
      );
      commit('changeSlipGaji', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_slip_gaji.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        commit('changeSlipGaji', {
          loading: false,
        });

        return true;
      }
    } else {
      let result = await ApiGetRequest(
        `slip-gaji/detail/${data.id_slip_periode}`,
        params,
      );
      commit('changeSlipGaji', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getListSlipGaji({ commit, state }, payload = {}) {
    commit('changeSlipGaji', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`slip-gaji`, params);
      commit('changeSlipGaji', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_slip_periode.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        commit('changeSlipGaji', {
          loading: false,
        });

        return true;
      }
    } else {
      let result = await ApiGetRequest(`slip-gaji`, params);
      commit('changeSlipGaji', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailSlipGaji({ commit }, payload = null) {
    commit('changeSlipGaji', {
      loading: true,
    });

    let result = await ApiGetRequest(`slip-gaji/${payload.id}`);
    commit('changeSlipGaji', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async uploadFileLembur({ commit, state }, payload) {
    commit('changeSlipGaji', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`upload-image`, payload);
    commit('changeSlipGaji', {
      loading: false,
    });

    if (!result.error) {
      commit('changeSlipGaji', {
        form: {
          ...data.form,
          file_lembur: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }, payload = null) {
    commit('changeSlipGaji', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(
      `slip-gaji/import/${payload.id_slip_periode}`,
      {
        items: data.import_form || [],
      },
    );

    commit('changeSlipGaji', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createSlipGaji({ commit, state, dispatch }) {
    commit('changeSlipGaji', {
      loading: true,
    });

    let result = await ApiPostRequest(`slip-gaji`, state.data.form);
    commit('changeSlipGaji', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateSlipGaji({ commit, state, dispatch }, payload = null) {
    commit('changeSlipGaji', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `slip-gaji/${payload.id}`,
      state.data.form,
    );

    commit('changeSlipGaji', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateStatusGaji({ commit, dispatch }, payload = null) {
    commit('changeSlipGaji', {
      loading: true,
    });

    let result = await ApiPostRequest(`slip-gaji/update-status`, {
      publish: 1,
      id_slip_periode: payload.id ? payload.id : '',
    });

    commit('changeSlipGaji', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteSlipGaji({ commit, dispatch }, payload = null) {
    commit('changeSlipGaji', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`slip-gaji/${payload.id}`);
    commit('changeSlipGaji', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async deleteDetailSlipGaji({ commit, dispatch }, payload = null) {
    commit('changeSlipGaji', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`slip-gaji/detail/${payload.id}`);
    commit('changeSlipGaji', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
